import React from 'react';
import { IconSvgProps } from '@models/common';

const TextHighlight: React.FC<IconSvgProps> = (props) => {
  const { size = 16, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.94285 9.39057L2.66666 11.6667V13.3334H4.33333L6.60952 11.0572M4.94285 9.39057L9.39048 4.94295C9.91019 4.42324 10.7529 4.42324 11.2726 4.94295L11.0572 4.72752C11.5769 5.24723 11.5769 6.08995 11.0572 6.60966L6.60952 11.0572M4.94285 9.39057L6.60952 11.0572'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.66666 14H13.3333'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default TextHighlight;
